import { createRouter, createWebHistory } from 'vue-router';

// import homeRoutes from './routes/home';
import mfaSetupRoutes from './routes/mfaSetup';
import mfaConfirmationRoutes from './routes/mfaConfirmation';
import listViewRoutes from './routes/listView';
import loginRoutes from './routes/login';
import resetPasswordRoutes from './routes/resetPassword';
import appHeaderRoutes from './routes/appHeader';
import landingRoutes from './routes/landing';
import ssoLoadingRoutes from './routes/sso';
import { useUserStore } from '@/store/user';

const routes = [
  // ...homeRoutes,
  ...mfaSetupRoutes,
  ...mfaConfirmationRoutes,
  ...listViewRoutes,
  ...resetPasswordRoutes,
  ...loginRoutes,
  ...appHeaderRoutes,
  ...landingRoutes,
  ...ssoLoadingRoutes
];

const router = createRouter({
  history: createWebHistory("/"),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const userStore = useUserStore()
  const isAuthenticated = !!userStore.userId
  if (to.meta.requiresAuth && !isAuthenticated) {
    return next({ path: 'login' })
  }
  next()
})

export default router;
